<template>
  <div class="container">
    <div class="page_headers footerTabs">
      <div class="page_header_left">
        <div class="mwow-button-filled primary" @click="clickexport">导出</div>
      </div>
      <div class="page_header_control">
        <div class="purchasedLable">
          到课{{ studentcount.attend_num }}次、 未到课{{
            studentcount.absent_num
          }}次、 迟到{{ studentcount.late_num }}次、 请假{{
            studentcount.leave_num
          }}次
        </div>
      </div>
    </div>
    <common-search-form-wrapper :reset="handleSearchReset">
      <el-form size="mini" ref="form" :model="searchInfo" label-width="80px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="上课时间:">
              <!-- <el-date-picker
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                v-model="expireTimeClass"
                @change="datechooseClass"
              >
              </el-date-picker> -->
              <common-date-range-selector
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                v-model="expireTimeClass"
                @change="datechooseClass(expireTimeClass)"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="签到状态:">
              <el-select
                v-model.number="searchInfo.student_status"
                clearable
                placeholder="请选择"
                @change="handleSearch"
                class="drawer_onlychoose"
              >
                <el-option
                  v-for="item in student_status"
                  :key="item.value"
                  :label="item.value"
                  :value="Number(item.key)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="班级名称:">
              <el-select
                v-model.number="searchInfo.class_id"
                filterable
                clearable
                placeholder="请选择"
                @clear="getSelectrList('class')"
                :filter-method="handleClassList"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in className"
                  :key="item.class_id"
                  :label="item.name"
                  :value="Number(item.class_id)"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="上课教室:">
              <el-select
                v-model="searchInfo.classroom_id"
                placeholder="请选择"
                @change="handleSearch"
                clearable
              >
                <el-option
                  v-for="item in searchClassRoomList"
                  :key="item.classroom_id"
                  :label="item.name"
                  :value="item.classroom_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="排课课程:">
              <el-select
                v-model.number="searchInfo.course_id"
                filterable
                clearable
                placeholder="请选择"
                @change="handleSearch"
                @clear="getSelectrList('course')"
                :filter-method="handleCourseList"
              >
                <el-option
                  v-for="item in courseName"
                  :key="item.course_id"
                  :label="item.title"
                  :value="Number(item.course_id)"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="科目:">
              <el-select
                v-model="searchInfo.subject_ids"
                multiple
                filterable
                default-first-option
                :filter-method="handleSubjectList"
                placeholder="请选择"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in subjectsList"
                  :key="item.subject_id"
                  :label="item.subject_title"
                  :value="item.subject_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="授课教师:">
              <common-staff-pull-down
                :originId.sync="searchInfo.teacher_id"
                :defaultSelected.sync="searchInfo.teacher_list"
                :jobIds="[1]"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="点名人员:">
              <common-staff-pull-down
                :originId.sync="searchInfo.staff_id"
                :defaultSelected.sync="searchInfo.staff_list"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="点名时间:">
              <!-- <el-date-picker
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                v-model="expireTime"
                @change="datechoose"
              >
              </el-date-picker> -->
              <common-date-range-selector
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                v-model="expireTime"
                @change="datechoose(expireTime)"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="班级类型:" prop="course_type">
              <el-radio-group
                v-model="searchInfo.course_type"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="1">1vN</el-radio-button>
                <el-radio-button :label="2">1v1</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="课耗状态:" prop="exceed_status">
              <el-radio-group
                v-model="searchInfo.exceed_status"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="1">未超上</el-radio-button>
                <el-radio-button :label="2">已超上</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="点名状态:" prop="status_type">
              <el-radio-group
                v-model="searchInfo.status_type"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="1">正常</el-radio-button>
                <el-radio-button :label="2">已撤销</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      size="mini"
      v-horizontal-scroll
      ref="multipleTable"
      tooltip-effect="dark"
      style="width: 100%"
      border
      :data="tableData"
      stripe
      @sort-change="handleSortChange"
      :default-sort="{
        prop: 'lesson_date',
        order: 'descending',
      }"
    >
      <el-table-column label="签到状态">
        <template slot-scope="scope">
          <div
            :class="[
              scope.row.student_status == 1
                ? 'editBtn'
                : scope.row.student_status == 2
                ? 'delBtn'
                : scope.row.student_status == 3
                ? 'closeBtn'
                : 'orderClose',
            ]"
          >
            {{ scope.row.student_statusName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="点名时间"
        width="180"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
        prop="lesson_date"
      >
        <template slot-scope="scope">
          <div>
            {{
              getAlreadyTime(new Date(Number(scope.row.roll_call_time + "000")))
            }}
            <!-- {{scope.row.lesson_date}} -->
          </div>
        </template>
      </el-table-column>
      <el-table-column label="点名状态">
        <template slot-scope="scope">
          {{ scope.row.status === 1 ? "正常" : "已撤销" }}
        </template>
      </el-table-column>
      <el-table-column label="点名人员" prop="staff.name"> </el-table-column>
      <el-table-column label="班级名称" prop="class.name"></el-table-column>
      <el-table-column label="班级类型" prop="course_type" width="90">
        <template slot-scope="scope">{{
          scope.row.class.course_type === 1 ? "1vN" : "1v1"
        }}</template>
      </el-table-column>
      <el-table-column label="上课教室" prop="classroom.name">
        <template slot-scope="scope">{{
          scope.row.classroom ? scope.row.classroom.name : "-"
        }}</template>
      </el-table-column>
      <el-table-column label="排课课程" prop="course.title"></el-table-column>
      <el-table-column
        label="排课课时"
        prop="default_consume_number"
        width="90"
      ></el-table-column>
      <el-table-column
        label="上课时间"
        width="250"
        prop="class_lesson.date"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      >
        <template slot-scope="scope">
          <div>
            {{ getTime(new Date(scope.row.class_lesson.date)) }}
            {{ scope.row.class_lesson.start_time }} -
            {{ scope.row.class_lesson.end_time }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="授课教师">
        <template slot-scope="scope">
          <div
            v-if="scope.row.teacher_list && scope.row.teacher_list.length > 0"
          >
            <span v-for="(item, index) in scope.row.teacher_list" :key="index"
              >{{
                index != scope.row.teacher_list.length - 1
                  ? item.name + ","
                  : item.name
              }}
            </span>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="耗课数">
        <template slot="header">
          <div class="selfheader">
            <div>耗课数</div>
            <el-popover
              placement="top"
              width="190"
              popper-class="followuppopover"
              trigger="hover"
            >
              <p class="tipck">点名签到后，所扣除的课程课时数</p>
              <div class="question" slot="reference">
                <div>?</div>
              </div>
            </el-popover>
          </div>
        </template>
        <template slot-scope="scope">
          <div>
            {{
              scope.row.exceed_status == 1
                ? scope.row.real_consume_number
                : scope.row.exceed_number
            }}
          </div>
        </template>
      </el-table-column> -->
      <el-table-column label="耗课数" prop="real_consume_number">
        <template slot-scope="scope">
          {{ scope.row.real_consume_number }}
          <span class="mwow-red" v-if="scope.row.exceed_number > 0"
            >(超上{{ scope.row.exceed_number }}课时)</span
          >
        </template>
      </el-table-column>
      <!-- <el-table-column label="课消金额">
        <template slot-scope="scope">
          <div>￥{{ scope.row.consume_amount }}</div>
        </template>
      </el-table-column> -->
      <el-table-column>
        <template slot="header">
          <div class="selfheader">
            <div>课消金额</div>
            <el-popover
              placement="top"
              width="190"
              popper-class="followuppopover"
              trigger="hover"
            >
              <p class="tipck">
                仅统计课时消耗产生的课消金额，免费赠送不计算金额
              </p>
              <div class="question" slot="reference">
                <div>?</div>
              </div>
            </el-popover>
          </div>
        </template>
        <template slot-scope="scope">
          <div>￥{{ scope.row.consume_amount }}</div>
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="remark">
        <template slot-scope="scope">
          <div>{{ scope.row.remark || "-" }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="上课内容"
        width="260"
        prop="class_lesson_extend.content"
        class-name="classCon"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.class_lesson_extend.content">
            {{ scope.row.class_lesson_extend.content }}
          </span>
          <span v-else> - </span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100" align="center">
        <template slot-scope="scope">
          <div
            class="mwow-button primary"
            @click="gorollcallDetails(scope.row)"
            v-if="scope.row.status === 1"
          >
            查看
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      :style="{ float: 'right', padding: '17px' }"
    >
    </el-pagination>
  </div>
</template>
<script>
import { exportStudentroll, getstudentcount } from "@/api/studyDetails";
import { exportLoop } from "@/utils/export";
import { rollCallStudentList } from "@/api/rollCall";
import { dateFormat } from "@/utils/timeFormat";
import { classroomSelectListApi } from "@/api/classRoom";
import { PageModule } from "@/store/module/page";
import {
  staffList,
  geteacherList,
  getSelectClassList,
  getSelectCourseList,
  getSeleSubjectsList,
} from "@/api/globalSearch";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

export default {
  components: {
    commonSearchFormWrapper,
    commonStaffPullDown,
    commonDateRangeSelector,
  },
  // @Prop() sid!: number;
  props: ["sid"],
  data() {
    return {
      searchInfo: {
        sort_type: "desc",
        sort_field: "",
        student_status: "",
        subject_ids: [],
        classroom_id: "",
        course_type: -1,
        exceed_status: -1,
        status_type: -1,
        teacher_id: "",
        teacher_list: [],
        staff_id: "",
        staff_list: [],
      },
      student_status: [
        { key: 1, value: "到课" },
        { key: 2, value: "迟到" },
        { key: 3, value: "请假" },
        { key: 4, value: "未到" },
      ], // 签到状态
      searchClassRoomList: [],
      expireTime: "", //点名时间
      courseName: [], //课程名字
      className: [], //班级名字
      teacherName: [], //老师名字
      staffName: [], //员工名字
      expireTimeClass: "", //课次时间
      studentcount: {},
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 20],
      id: 0,
      subjectsList: [], // 科目列表
      staffList: [], // 点名人员列表
    };
  },

  created() {
    if (PageModule.latestRoute === "rollCallDetails") {
      const cache = PageModule.pageInfo.studentDetailSigned;
      if (cache.search_info) {
        this.searchInfo = cache.search_info;
      }
      if (cache.page) {
        this.page = cache.page;
      }
      if (cache.page_size) {
        this.pageSize = cache.page_size;
      }
    }
    this.id = this.sid;
    this.getrollcallistData({
      page: this.page,
      page_size: this.pageSize,
      sort_field: "lesson_full_start_time",
    });
    this.handleClassList("");
    this.handleCourseList("");
    this.handleSubjectList("");
    classroomSelectListApi({
      page: 1,
      page_size: 1000,
    }).then((res) => {
      if (res.error_code === 0) {
        this.searchClassRoomList = res.data.list;
      }
    });
  },

  methods: {
    handleClassList(v) {
      getSelectClassList({
        page: 1,
        page_size: 1000,
        name: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.className = res.data.list;
        }
      });
    },
    handleSubjectList(v) {
      getSeleSubjectsList({
        page: 1,
        page_size: 500,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.subjectsList = res.data.list;
        }
      });
    },
    handleCourseList(v) {
      getSelectCourseList({
        page: 1,
        page_size: 1000,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.courseName = res.data.list;
        }
      });
    },
    // 导出开始
    clickexport(data) {
      const _t = this;
      data.student_id = _t.id;
      if (_t.searchInfo.teacher_id != "") {
        data.teacher_id = _t.searchInfo.teacher_id;
      }
      if (_t.searchInfo.class_id != "") {
        data.class_id = _t.searchInfo.class_id;
      }
      if (_t.searchInfo.course_id != "") {
        data.course_id = _t.searchInfo.course_id;
      }
      if (_t.searchInfo.roll_call_start_date != "") {
        data.roll_call_start_date = _t.searchInfo.roll_call_start_date;
      }
      if (_t.searchInfo.roll_call_end_date != "") {
        data.roll_call_end_date = _t.searchInfo.roll_call_end_date;
      }
      if (_t.searchInfo.lesson_start_date != "") {
        data.lesson_start_date = _t.searchInfo.lesson_start_date;
      }
      if (_t.searchInfo.lesson_end_date != "") {
        data.lesson_end_date = _t.searchInfo.lesson_end_date;
      }
      if (_t.searchInfo.status_type > -1) {
        data.status = _t.searchInfo.status_type;
      }
      exportStudentroll(data).then((res) => {
        if (res.error_code == 0) {
          exportLoop(res.data.task_id);
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    // 已点名
    getrollcallistData(data) {
      const _t = this;
      data.student_id = _t.id;
      if (_t.searchInfo.teacher_id != "") {
        data.teacher_id = _t.searchInfo.teacher_id;
      }
      if (_t.searchInfo.class_id != "") {
        data.class_id = _t.searchInfo.class_id;
      }
      if (_t.searchInfo.course_id != "") {
        data.course_id = _t.searchInfo.course_id;
      }
      if (_t.searchInfo.roll_call_start_date != "") {
        data.roll_call_start_date = _t.searchInfo.roll_call_start_date;
      }
      if (_t.searchInfo.roll_call_end_date != "") {
        data.roll_call_end_date = _t.searchInfo.roll_call_end_date;
      }
      if (_t.searchInfo.lesson_start_date != "") {
        data.lesson_start_date = _t.searchInfo.lesson_start_date;
      }
      if (_t.searchInfo.lesson_end_date != "") {
        data.lesson_end_date = _t.searchInfo.lesson_end_date;
      }
      if (_t.searchInfo.student_status != "") {
        data.student_status = _t.searchInfo.student_status;
      }
      if (_t.searchInfo.sort_type != "") {
        data.sort_type = _t.searchInfo.sort_type;
      }
      if (_t.searchInfo.sort_field != "") {
        data.sort_field = _t.searchInfo.sort_field;
      }
      if (_t.searchInfo.subject_ids.length > 0) {
        data.subject_ids = _t.searchInfo.subject_ids;
      }
      if (_t.searchInfo.classroom_id != "") {
        data.classroom_id = _t.searchInfo.classroom_id;
      }
      if (_t.searchInfo.staff_id != "") {
        data.staff_id = _t.searchInfo.staff_id;
      }
      if (_t.searchInfo.course_type > -1) {
        data.course_type = Number(_t.searchInfo.course_type);
      }
      if (_t.searchInfo.exceed_status > -1) {
        data.exceed_status = Number(_t.searchInfo.exceed_status);
      }
      if (_t.searchInfo.status_type > -1) {
        data.status = _t.searchInfo.status_type;
      }
      // 已点名课时接口
      rollCallStudentList(data).then((res) => {
        if (res.error_code == 0) {
          _t.getstudentcountData();
          res.data.list.map((a) => {
            a.createdTimeData = dateFormat(
              "YYYY-mm-dd HH:MM",
              new Date(Number(a.create_time + "000"))
            );
            switch (a.student_status) {
              case 1:
                a.student_statusName = "到课";
                break;
              case 2:
                a.student_statusName = "迟到";
                break;
              case 3:
                a.student_statusName = "请假";
                break;
              case 4:
                a.student_statusName = "未到课";
                break;
            }
            a.lesson_start_time = a.class_lesson.start_time.slice(
              0,
              a.class_lesson.start_time.lastIndexOf(":")
            );

            a.lesson_end_time = a.class_lesson.end_time.slice(
              0,
              a.class_lesson.end_time.lastIndexOf(":")
            );
          });
          _t.tableData = res.data.list;
          _t.total = res.data.total;
          _t.page = res.data.page;
        }
      });
    },
    getstudentcountData() {
      const _t = this;
      const data = {};
      data.student_id = _t.id;
      if (_t.searchInfo.teacher_id != "") {
        data.teacher_id = _t.searchInfo.teacher_id;
      }
      if (_t.searchInfo.class_id != "") {
        data.class_id = _t.searchInfo.class_id;
      }
      if (_t.searchInfo.course_id != "") {
        data.course_id = _t.searchInfo.course_id;
      }
      if (_t.searchInfo.roll_call_start_date != "") {
        data.roll_call_start_date = _t.searchInfo.roll_call_start_date;
      }
      if (_t.searchInfo.roll_call_end_date != "") {
        data.roll_call_end_date = _t.searchInfo.roll_call_end_date;
      }
      if (_t.searchInfo.lesson_start_date != "") {
        data.lesson_start_date = _t.searchInfo.lesson_start_date;
      }
      if (_t.searchInfo.lesson_end_date != "") {
        data.lesson_end_date = _t.searchInfo.lesson_end_date;
      }
      getstudentcount(data).then((res) => {
        if (res.error_code == 0) {
          _t.studentcount = res.data;
        }
      });
    },
    // 排序请求
    handleSortChange(e) {
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      if (e.prop == "class_lesson.date") {
        this.searchInfo.sort_field = "lesson_full_start_time";
        this.getrollcallistData({
          page: 1,
          page_size: this.pageSize,
        });
      } else if (e.prop == "lesson_date") {
        this.searchInfo.sort_field = "roll_call_time";
        this.getrollcallistData({
          page: 1,
          page_size: this.pageSize,
        });
      }
    },
    getAlreadyTime(e) {
      const weekZh = ["日", "一", "二", "三", "四", "五", "六"];
      const v = "（周" + weekZh[e.getDay()] + "）";
      const format = dateFormat("YYYY-mm-dd HH:MM", e);
      return format.slice(0, 10) + v + format.slice(11);
    },
    // 周几
    getTime(e) {
      const weekZh = ["日", "一", "二", "三", "四", "五", "六"];
      const v = "（周" + weekZh[e.getDay()] + "）";
      const format = dateFormat("YYYY-mm-dd", e);
      return format.slice(0, 10) + v + format.slice(11);
    },
    datechoose(e) {
      const _t = this;
      let expire_start_time = "";
      let expire_end_time = "";
      if (e != null) {
        expire_start_time = e[0];
        expire_end_time = e[1];
      }
      _t.searchInfo.roll_call_start_date = expire_start_time;
      _t.searchInfo.roll_call_end_date = expire_end_time;
      // _t.handleSearch();
      _t.getrollcallistData({
        page: _t.page,
        page_size: _t.pageSize,
      });
    },
    datechooseClass(e) {
      const _t = this;
      let expire_start_time = "";
      let expire_end_time = "";
      if (e != null) {
        expire_start_time = e[0];
        expire_end_time = e[1];
      }
      _t.searchInfo.lesson_start_date = expire_start_time;
      _t.searchInfo.lesson_end_date = expire_end_time;
      _t.handleSearch();
    },
    // 筛选
    handleSearch() {
      const _t = this;
      _t.page = 1;
      _t.getrollcallistData({
        page: _t.page,
        page_size: _t.pageSize,
      });
    },
    // 查看
    gorollcallDetails(e) {
      PageModule.SET_PAGE_INFO({
        name: "studentDetailSigned",
        key: "search_info",
        value: { ...this.searchInfo },
      });
      const _t = this;
      _t.$router.push({
        name: "rollCallDetails",
        query: { id: e.roll_call_id },
      });
    },
    async globalSearch(queryString, type) {
      const _t = this;
      let data = {
        page: 1,
        page_size: 100,
      };
      let restaurants = {};
      if (queryString) {
        data = {
          page: 1,
          page_size: 10,
        };
        if (type == "class") {
          data.name = queryString;
        } else if (type == "course") {
          data.title = queryString;
        } else {
          data.key_word = queryString;
        }
      }
      restaurants = await _t.getglobalsearchdata(data, type);
      const list = restaurants.data.list;
      if (type == "staff") {
        _t.staffName = list;
      } else if (type == "teacher") {
        _t.teacherName = list;
      } else if (type == "class") {
        _t.className = list;
      } else if (type == "course") {
        _t.courseName = list;
      }
    },
    getglobalsearchdata(data, type) {
      if (type == "staff") {
        return staffList(data);
      } else if (type == "teacher") {
        return geteacherList(data);
      } else if (type == "class") {
        return getSelectClassList(data);
      } else if (type == "course") {
        return getSelectCourseList(data);
      }
    },
    getSelectrList(e) {
      const _t = this;
      _t.globalSearch("", e);
    },
    handlePagerChange(e) {
      PageModule.SET_PAGE_INFO({
        name: "studentDetailSigned",
        key: "page",
        value: e,
      });
      this.page = e;
      this.getrollcallistData({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      PageModule.SET_PAGE_INFO({
        name: "studentDetailSigned",
        key: "page_size",
        value: e,
      });
      this.pageSize = e;
      this.getrollcallistData({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    handleSearchReset() {
      this.searchInfo = {
        sort_type: "desc",
        sort_field: "roll_call_time",
        student_status: "",
        subject_ids: [],
        staff_id: "",
        classroom_id: "",
        course_type: -1,
        exceed_status: -1,
        status_type: -1,
      };
      this.handleSearch();
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  .footerTabs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    .purchasedLable {
      height: 30px;
      text-align: center;
      line-height: 30px;
      width: 270px;
      color: #5c5d5e;
      background: #fff7e9;
    }
  }
  .selfheader {
    display: flex;
    align-items: center;
  }
  .question {
    width: 15px;
    height: 15px;
    opacity: 1;
    background: #bebfc0;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    line-height: 16px;
    font-size: 10px;
    margin-left: 5px;
  }
  /deep/ .classCon {
    .cell {
      width: 22em;
      overflow: hidden; /*超出部分隐藏*/
      white-space: nowrap; /*禁止换行*/
      text-overflow: ellipsis;
    }
  }
}
.editBtn {
  color: #07d1aa;
}
.closeBtn {
  color: #ffb940;
}
.delBtn {
  color: #5c5d5e;
}
.orderClose {
  color: #f56c6c;
}
</style>
